import script from "./QuoteAddressManager.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteAddressManager.vue?vue&type=script&setup=true&lang=js"

import "./QuoteAddressManager.vue?vue&type=style&index=0&id=f2cfdbb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2cfdbb4"]])

export default __exports__